const RATE_LIMIT_DOCS_URL = 'https://docs.stride.zone'

export { RATE_LIMIT_DOCS_URL }
